
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.87 12.347a1.008 1.008 0 01-1.426 0l-2.135-2.134a1.008 1.008 0 011.426-1.426l1.421 1.421 5.792-5.792a7.976 7.976 0 00-5.647-2.346c-2.201 0-4.202.9-5.651 2.35a7.976 7.976 0 00-2.35 5.65c0 2.201.9 4.202 2.35 5.651a7.976 7.976 0 005.65 2.35c2.202 0 4.202-.9 5.651-2.35a7.976 7.976 0 002.35-5.65 7.936 7.936 0 00-1.107-4.049l-6.324 6.325z","fill":"#33C173"}})])
          )
        }
      }
    